<template>
  <div>
    <v-toolbar dense flat>
      <v-app-bar-nav-icon to="/product/home" small>
        <v-icon>home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>Product</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Switch to menu on md and smaller (tablet included) -->
      <v-menu offset-y v-if="$vuetify.breakpoint.mdAndDown">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            {{ selectedLabel }}
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="selectItem('Product List', '/product/list')">
            <v-list-item-title>Product List</v-list-item-title>
          </v-list-item>

          <v-list-item
            :disabled="!currentBusiness.metadata.collections"
            @click="selectItem('Collections', '/product/collection/list')"
          >
            <v-list-item-title>Collections</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="selectItem('Category', '/product/category/list')"
          >
            <v-list-item-title>Category</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="selectItem('Department', '/product/department/list')"
          >
            <v-list-item-title>Department</v-list-item-title>
          </v-list-item>

          <v-list-item @click="selectItem('Brand', '/product/brand/list')">
            <v-list-item-title>Brand</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="currentBusiness && currentBusiness.metadata && !currentBusiness.metadata.isSingleCustomerPricing"
            @click="selectItem('Price Tier', '/product/PriceTier/list')"
          >
            <v-list-item-title>Price Tier</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Desktop full toolbar -->
      <div v-else>
        <v-btn text color="teal" dark to="/product/list">Product List</v-btn>

        <v-btn
          text
          color="teal"
          :dark="currentBusiness && currentBusiness.metadata && currentBusiness.metadata.collections"
          :disabled="!currentBusiness || !currentBusiness.metadata || !currentBusiness.metadata.collections"
          to="/product/collection/list"
        >
          Collections
        </v-btn>

        <v-btn text color="teal" dark to="/product/category/list"
          >Category</v-btn
        >

        <v-btn text color="teal" dark to="/product/department/list">
          Department
        </v-btn>

        <v-btn text color="teal" dark to="/product/brand/list">Brand</v-btn>

        <v-btn
          text
          color="teal"
          dark
          to="/product/PriceTier/list"
          v-if="currentBusiness && currentBusiness.metadata && !currentBusiness.metadata.isSingleCustomerPricing"
        >
          Price Tier
        </v-btn>
      </div>
    </v-toolbar>
    <v-divider></v-divider>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "product",
  data() {
    return {
      selectedLabel: "Product List",
    };
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },
  methods: {
    selectItem(label, route) {
      this.selectedLabel = label;
      this.$router.push(route);
    },
  },
};
</script>
